import { Link, NavLink, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userId");
    navigate("/");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg px-0 py-1 mb-1 sticky-top">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img
              src="/assets/images/fndrma-logo.png"
              width="200"
              alt=""
              className="d-lg-block d-none"
            />
            <img
              src="/assets/images/fndrma-logo.png"
              width="150"
              alt=""
              className="d-lg-none d-block"
            />
          </Link>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div className="me-5">
              <a
                href="#https://www.facebook.com/share/1Y6ZwUNye6/"
                target="_blank"
                className="me-2"
              >
                <i className="bi bi-facebook fs-4 me-2 text-dark"></i>
              </a>
              <a href="#" className="me-2">
                <i className="bi bi-twitter fs-4 me-2 text-dark"></i>
              </a>
              <a
                href="https://www.instagram.com/fundoramaa?igsh=ZDlqd21jN2dmMzNm"
                target="_blank"
              >
                <i className="bi bi-instagram fs-4 text-dark"></i>
              </a>
            </div>
            <div class="d-none d-md-block">
              <button
                onClick={handleLogout}
                class="btn btn-primary px-5 rounded-3 text-white"
              >
                Logout
              </button>
              <Link to="/filmmaker/profile" class="rounded-circle ms-3">
                <div class="avatar avatar-md avatar-indicators avatar-online">
                  <img
                    alt="avatar"
                    src="https://cdn-icons-png.flaticon.com/512/17948/17948614.png"
                    class="rounded-4"
                  />
                </div>
              </Link>
            </div>
          </div>
          <div>
            <button
              className="navbar-toggler collapsed ms-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar mt-0" />
              <span className="icon-bar middle-bar" />
              <span className="icon-bar bottom-bar" />
            </button>
          </div>
          <div className="collapse navbar-collapse ps-lg-5" id="navbar-default">
            <ul className="navbar-nav mt-3 mt-lg-0">
              <li className="nav-item">
                <NavLink to="/filmmaker/dashboard" className="nav-link">
                  Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/filmmaker/projects" className="nav-link">
                  Projects
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/filmmaker/unreleased" className="nav-link">
                  Unreleased
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/filmmaker/released" className="nav-link">
                  Released <span class="badge bg-primary ms-2">New</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/filmmaker/profile" className="nav-link">
                  Manage Profile
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
